import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import { Dates } from "@utils/Dates";
import { Numbers } from "@utils/Numbers";

import { Currency } from "@utils/Currency";
import classNames from "classnames";
const css = classNames.bind(styles);

export default function ({ customer }) {
  const calcTicket = (total_orders, count_orders) => {
    return Currency.formatCurrency(total_orders / (count_orders || 1) || 0);
  };

  const cashbackProgram = localStorage.getItem("cashbackProgram");
  const program = JSON.parse(cashbackProgram);

  const programByPoint = program?.type === "POINT";

  return (
    <div className={styles.consumptionData}>
      <p className={styles.title}>Dados de consumo</p>
      <div className={styles.boxes}>
        <div className={styles.box}>
          {customer.last_conversion_at ? (
            <p>{Dates.toDateBRL(customer.last_conversion_at)}</p>
          ) : (
            <p className={styles.empty}>---</p>
          )}
          <span>Última conversão</span>
        </div>
        <div className={styles.box}>
          {customer.count_orders ? (
            <p>{Numbers.formatInt(customer.count_orders || 0)}</p>
          ) : (
            <p className={styles.empty}>---</p>
          )}
          <span>Quantidade de pedidos</span>
        </div>
      </div>

      <ul>
        <li className={styles.item}>
          <span>
            {programByPoint ? "Pontos acumulados" : "Cashback acumulado"}
          </span>
          <p
            className={css({
              empty: !+customer.cashback_total,
            })}
          >
            {programByPoint
              ? +customer.cashback_total
              : Currency.formatCurrency(+customer.cashback_total || 0)}
          </p>
        </li>
        <li className={styles.item}>
          <span>Ticket Médio</span>
          <p
            className={css({
              empty: true,
            })}
          >
            {calcTicket(customer.total_orders || 0, customer.count_orders || 1)}
          </p>
        </li>
        <li className={styles.item}>
          <span>Total gasto</span>
          <p
            className={css({
              empty: !+customer.total_orders,
            })}
          >
            {Currency.formatCurrency(+customer.total_orders || 0)}
          </p>
        </li>
        <li className={styles.item}>
          <span>Data de cadastro</span>
          <p
            className={css({
              empty: !customer.created_at,
            })}
          >
            {customer?.created_at?.replace(
              /(\d{4})-(\d{2})-(\d{2})T.*/,
              "$3/$2/$1"
            )}
          </p>
        </li>
      </ul>
    </div>
  );
}
